"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../utils");

var abi_coder_1 = require("../abi-coder");

var contract_entry_1 = require("./contract-entry");

var ContractFunctionEntry = /*#__PURE__*/function (_contract_entry_1$Con) {
  _inherits(ContractFunctionEntry, _contract_entry_1$Con);

  function ContractFunctionEntry(entry) {
    var _this;

    _classCallCheck(this, ContractFunctionEntry);

    entry.inputs = entry.inputs || [];
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ContractFunctionEntry).call(this, entry));
    _this.signature = entry.type === 'constructor' ? 'constructor' : abi_coder_1.abiCoder.encodeFunctionSignature(abi_coder_1.abiCoder.abiMethodToString(entry));
    return _this;
  }

  _createClass(ContractFunctionEntry, [{
    key: "numArgs",
    value: function numArgs() {
      return this.entry.inputs ? this.entry.inputs.length : 0;
    }
  }, {
    key: "decodeReturnValue",
    value: function decodeReturnValue(returnValue) {
      if (!returnValue) {
        return null;
      }

      var result = abi_coder_1.abiCoder.decodeParameters(this.entry.outputs, returnValue);

      if (result.__length__ === 1) {
        return result[0];
      } else {
        delete result.__length__;
        return result;
      }
    }
  }, {
    key: "encodeABI",
    value: function encodeABI(args) {
      return Buffer.concat([utils_1.hexToBuffer(this.signature), this.encodeParameters(args)]);
    }
  }, {
    key: "encodeParameters",
    value: function encodeParameters(args) {
      return utils_1.hexToBuffer(abi_coder_1.abiCoder.encodeParameters(this.entry.inputs, args));
    }
  }, {
    key: "decodeParameters",
    value: function decodeParameters(bytes) {
      return abi_coder_1.abiCoder.decodeParameters(this.entry.inputs, utils_1.bufferToHex(bytes));
    }
  }, {
    key: "constant",
    get: function get() {
      return this.entry.stateMutability === 'view' || this.entry.stateMutability === 'pure' || this.entry.constant;
    }
  }, {
    key: "payable",
    get: function get() {
      return this.entry.stateMutability === 'payable' || this.entry.payable;
    }
  }]);

  return ContractFunctionEntry;
}(contract_entry_1.ContractEntry);

exports.ContractFunctionEntry = ContractFunctionEntry;